export interface AssistantRateLimitBannerProps {
  /** Pre-formatted reset time (e.g. via toLocaleString(), or "midnight UTC"). */
  formattedResetAt: string
  onDismiss: () => void
}

/**
 * Amber "daily AI budget reached" banner. Pure/props-driven — the caller owns
 * the rate-limited state check and the reset-time formatting.
 */
export function AssistantRateLimitBanner({ formattedResetAt, onDismiss }: AssistantRateLimitBannerProps) {
  return (
    <div
      role="alert"
      className="flex items-start justify-between gap-[0.5em] border-b border-amber-200 bg-amber-50 px-[0.75em] py-[0.5em] text-[0.72em] text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-100"
    >
      <span>Daily AI budget reached. This chatbot will be available again at {formattedResetAt}.</span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss rate limit notice"
        title="Dismiss"
        className="shrink-0 rounded px-[0.375em] py-[0.125em] text-[0.62em] font-medium text-amber-900 hover:bg-amber-100 dark:text-amber-100 dark:hover:bg-amber-800/40"
      >
        Dismiss
      </button>
    </div>
  )
}
